module.exports = __webpack_public_path__ + "img/chrome.bc41f155.svg";